import isEmpty from 'lodash/isEmpty';
import logger from '@tcp/core/src/utils/loggerInstance';
import { getSessionStorage, setSessionStorage } from '@tcp/core/src/utils';
import { CONTACT_FORM } from './ContactForm.constant';

export const setContactFormValuesInSS = (savedContactInfo) => {
  setSessionStorage({ key: CONTACT_FORM, value: JSON.stringify(savedContactInfo) });
};

export const getContactFormValuesFromSS = () => {
  try {
    let savedContactFormData = getSessionStorage(CONTACT_FORM);
    savedContactFormData =
      (savedContactFormData &&
        savedContactFormData !== 'undefined' &&
        JSON.parse(savedContactFormData)) ||
      {};
    return savedContactFormData;
  } catch (e) {
    logger.error('Error in getContactFormValuesFromSS', e);
    return {};
  }
};

export const checkContactFormValuesInSS = () => {
  const savedContactFormInputs = getContactFormValuesFromSS();
  return (
    !isEmpty(savedContactFormInputs?.emailAddress) && !isEmpty(savedContactFormInputs?.phoneNumber)
  );
};

/**
 * Get ContactForm Values based on logged in status and session storage values
 *
 * @returns Contact Form Values
 */

export const getPhoneNumberValue = (isLoggedIn, contactFormValuesFromSS, loggedInUser) => {
  if (isLoggedIn && !contactFormValuesFromSS?.phoneNumber) {
    return { ...contactFormValuesFromSS, phoneNumber: loggedInUser?.phoneNumber };
  }
  return { ...contactFormValuesFromSS };
};

export const getContactFormValues = ({
  isLoggedIn,
  loggedInUser,
  contactFormValuesFromSS,
  shippingContactInfo: {
    emailAddress: savedEmailAddress,
    phoneNumber: savedPhoneNumber,
    smsSignUp: savedSmsSignUp,
    emailSignUp: savedEmailSignUp,
  },
}) => {
  let initValues = {};
  let contactFormDetails = {};
  if (isLoggedIn) {
    initValues = { ...initValues, emailAddress: loggedInUser?.emailAddress };
    if (loggedInUser?.phoneNumber) {
      initValues = { ...initValues, phoneNumber: loggedInUser?.phoneNumber };
    }
  }
  if (savedEmailAddress) {
    initValues = { ...initValues, emailAddress: savedEmailAddress };
  }
  if (savedPhoneNumber) {
    initValues = { ...initValues, phoneNumber: savedPhoneNumber };
  }
  if (savedSmsSignUp) {
    initValues = { ...initValues, smsSignUp: savedSmsSignUp };
  }
  if (savedEmailSignUp) {
    initValues = { ...initValues, emailSignUp: savedEmailSignUp };
  }
  if (!isEmpty(contactFormValuesFromSS)) {
    contactFormDetails = { ...contactFormValuesFromSS };
    initValues = { ...initValues, ...contactFormDetails };
  }
  return initValues;
};
